var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "social-events" } },
    [
      _c("portal", { attrs: { to: "content-header" } }, [
        _c(
          "div",
          { key: "social-events-header", staticClass: "ci-content-header" },
          [
            _c("div", { staticClass: "ci-content-header__inner" }, [
              _c("h1", {
                staticClass: "h2",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.views.social_events.index.header.title")
                  ),
                },
              }),
              _c("div", {
                staticClass: "description",
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("ui.views.social_events.index.header.description")
                  ),
                },
              }),
            ]),
          ]
        ),
      ]),
      _vm.CurrentUser.signedIn
        ? [
            _vm.state == "success"
              ? [
                  _vm.events.length > 0
                    ? _c("event-list", { attrs: { events: _vm.events } })
                    : _c("events-empty-state", {
                        staticClass: "ci-card ci-content-padding p-xl-6",
                      }),
                ]
              : _vm._e(),
          ]
        : [_c("value-proposition")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }